'use client'

import dayjs from 'dayjs'
import React from 'react'

import { Button } from '../../../components/Button'
import { Modal, ModalProps } from '../../../components/Modal'
import { Typography } from '../../../components/Typography'
import { Container, Content } from './styles'

export interface FacilityAgreementModalProps extends ModalProps {
  title?: string
  facilityName: string
  content: string
  date: string
  submitLabel?: string
  onSubmit: (close?: () => void) => void | Promise<void>
}

export const FacilityAgreementModal = ({
  title = '施設利用約款',
  facilityName,
  content,
  date,
  submitLabel = '上記に同意して予約',
  onSubmit,
  ...modalProps
}: FacilityAgreementModalProps) => {
  const [isSubmitting, setIsSubmitting] = React.useState(false)

  return (
    <Modal title={title} {...modalProps}>
      <Modal.Body>
        <Container>
          <Typography as="p">
            {facilityName}
            をご利用いただくには、施設が定めている利用約款に同意する必要があります。
          </Typography>

          <Content>
            <Typography variant="body2" color="gray.01">
              {content}
            </Typography>
            <Typography
              variant="body2"
              color="gray.01"
              mt={2}
              textAlign="right"
            >
              {dayjs(date).format('YYYY年MM月DD日')}改定
            </Typography>
          </Content>
        </Container>
      </Modal.Body>

      <Modal.Footer>
        <Button
          variant="brand"
          size="lg"
          loading={isSubmitting}
          onClick={async () => {
            setIsSubmitting(true)
            await onSubmit(modalProps.onClose)
            setIsSubmitting(false)
          }}
          fullWidth
        >
          {submitLabel}
        </Button>
      </Modal.Footer>
    </Modal>
  )
}
